import { defineSlotRecipe } from '@chakra-ui/react'

export const avatar = defineSlotRecipe({
	className: 'avatar',
	slots: ['root', 'image', 'fallback'],
	variants: {
		size: {
			'3xl': {
				root: {
					'--avatar-size': '96px',
					'--avatar-font-size': '2rem'
				}
			}
		}
	}
})
